<template>
  <div class="home">
    <NavBar />
    <!-- HERO inicio section -->
    <section id="inicio" class="section">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div
          class="mx-auto max-w-2xl py-32 sm:py-0 lg:py-56 hidden sm:block animate-fade-in-down"
          style="animation-delay: 200ms"
        >
          <img class="h-96" :src="HerOptimuz" alt="Hero Optimuz" />
        </div>
        <div class="mx-auto max-w-2xl py-32 sm:py-0 lg:py-56">
          <div
            class="hidden sm:mb-8 sm:flex sm:justify-center animate-fade-in-down"
            style="animation-delay: 200ms"
          >
            <!-- <div class="relative rounded-full px-3 py-1 text-sm/6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
              Announcing our next round of funding. <a href="#" class="font-semibold text-indigo-600">
                <span class="absolute inset-0" aria-hidden="true"></span>Quiero saber más <span aria-hidden="true">&rarr;</span></a>
            </div> -->
          </div>
          <div class="text-center">
            <h1
              class="text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl animate-fade-in-right"
              style="animation-delay: 400ms"
            >
              Especialistas en sistemas RIS PACS.
            </h1>
            <p
              class="text-justify mx-2 mt-8 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 animate-fade-in-up"
              style="animation-delay: 600ms"
            >
              Descubra nuestro servicio de Integración RIS PACS, diseñado para transformar la forma
              en que gestiona los estudios de imagenología en su entorno médico. Con nuestra
              solución, podrá optimizar la programación de citas, el seguimiento de pacientes y la
              interpretación de imágenes, todo ello mientras mejora la eficiencia, la precisión y la
              accesibilidad de sus servicios de radiología.
            </p>
            <div
              class="mt-10 flex items-center justify-center gap-x-6 animate-fade-in-up"
              style="animation-delay: 800ms"
            >
              <a
                href="#contacto"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >Contáctanos
              </a>
              <a href="#" class="text-sm/6 font-semibold text-gray-900">
                <!-- Leer más <span aria-hidden="true">→</span> -->
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-HeroAzul"></div>
    </section>
    <!-- CArousel Optimuz section -->
    <section id="optimuz" class="section">
      <div class="py-24 sm:py-32">
        <div class="mx-auto max-w-7xl lg:px-8">
          <div class="subirOptimuz mx-auto max-w-sm md:max-w-2xl lg:text-center">
            <h2 class="text-base/7 font-semibold text-indigo-600">Te presentamos:</h2>
            <p
              class="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance text-white"
            >
              OPTIMUZ MRIS
            </p>
            <p class="mt-6 text-lg/8 text-gray-600 text-white">
              Plataforma on-premise y en la nube para la gestión de información clínica en
              radiología, que integra diversas herramientas de diagnóstico para optimizar el
              servicio de teleradiología en hospitales, clínicas y centros de imágenes diagnósticas.
            </p>
          </div>
          <div
            class="mx-auto max-w-screen-xl md:grid md:grid-cols-1 md:items-center md:gap-4 md:px-2 lg:grid-cols-2"
          >
            <div class="max-w-prose text-left fade-left">
              <div class="flex items-start mt-8-op">
                <svg
                  class="flex-shrink-0 text-green-500 w-9 h-9"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="{1.5}"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z"
                  />
                </svg>
                <div class="ml-5">
                  <h3 class="text-xl font-semibold text-indigo-600">Almacenamiento en la Nube</h3>
                  <p class="mt-3 text-base text-white">
                    Diseñado y desarrollado para su funcionamiento 100% nativo en la nube, con
                    tecnologías avanzadas de despliegue rápido y arquitectura versátil!
                  </p>
                </div>
              </div>

              <div class="flex items-start mt-6 mt-8-op">
                <svg
                  class="flex-shrink-0 text-blue-600 w-9 h-9"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>

                <div class="ml-5">
                  <h3 class="text-xl font-semibold text-indigo-600">Alta disponibilidad</h3>
                  <p class="mt-3 text-base text-white">
                    Más del 99,7% de disponibilidad, y más del 99,99% de durabilidad de la
                    información garantizada en nuestro SLA (ANS).
                  </p>
                </div>
              </div>

              <div class="flex items-start mt-6 mt-8-op">
                <svg
                  class="flex-shrink-0 text-red-500 w-9 h-9"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
                  />
                </svg>

                <div class="ml-5">
                  <h3 class="text-xl font-semibold text-indigo-600">Múltiples roles de usuario</h3>
                  <p class="mt-3 text-base text-white">
                    Lo que permite a cada miembro del equipo médico acceder y utilizar solo las
                    herramientas y funciones que necesita, mejorando la eficiencia y la calidad de
                    la atención al paciente.
                  </p>
                </div>
              </div>
            </div>

            <div class="mt-6 md:mt-0 sm:p-10 float-left fade-right">
              <Carousel :items="carouselItems" />

              <!-- <img
                class="w-full rounded-lg shadow-xl"
                src="https://cdn.rareblocks.xyz/collection/celebration/images/features/7/dashboard-screenshot.png"
                alt=""
              /> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Dictado section -->
    <section id="dictado" class="bg-gray-50 section">
      <!-- Agrego forma curva en la parte inferior -->
      <div class="bottom-0 left-0 w-full overflow-hidden leading-none">
        <svg
          class="relative block w-full h-24"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="fill-azul-100"
          ></path>
        </svg>
      </div>
      <div class="mx-auto w-screen max-w-screen-xl md:grid md:grid-cols-2 md:items-center md:gap-4">
        <div class="max-w-prose text-left text-center-op sectionAnimate">
          <h2 class="text-base/7 font-semibold text-indigo-600">
            Maximice la eficiencia de sus informes con...
          </h2>
          <h1 class="text-[42px] leading-10 font-bold text-gray-900 text-black">
            Dictado por Voz &
            <strong class="text-indigo-600"> Transcripción Automática </strong>
          </h1>

          <p
            class="mt-4 text-base text-pretty text-gray-700 sm:text-lg/relaxed text-dark text-justify"
          >
            ¡Lanzamos el nuevo componente de reconocimiento de voz para agilizar sus procesos!...
            edite reportes, inserte comandos, corrija texto y ajuste formatos utilizando solo su
            voz. Con la transcripción de audios en tiempo real, convierta sus grabaciones en
            reportes estructurados, aplicando plantillas personalizadas o predefinidas.
          </p>
        </div>

        <!-- Responsive Image -->
        <div class="mt-6 px-6 md:mt-0 sm:p-10 fade-right">
          <img
            class="w-full h-auto max-w-full rounded-lg object-cover md:h-[400px] lg:h-[500px]"
            :src="imagenDictado"
            alt="Dictado por Voz"
          />
        </div>
      </div>
    </section>

    <!-- Visor web section -->
    <section class="py-10 bg-gray-50 sm:py-16 lg:py-24">
      <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div class="grid items-stretch gap-y-10 md:grid-cols-2 md:gap-x-20">
          <div class="relative grid grid-cols-1 gap-6 mt-10 md:mt-0">
            <div class="relative">
              <div class="h-full overflow-hidden aspect-w-3 aspect-h-4">
                <img
                  class="rounded-lg w-[500px] fade-left"
                  :src="imgenVisorWeb"
                  alt="Visor Web de Diagnostico"
                />
              </div>
            </div>
          </div>

          <div class="flex flex-col xl:px-16 justify-center sectionAnimate">
            <h2 class="text-base/7 text-center font-semibold text-indigo-600">
              Olvídese de las instalaciones de software
            </h2>
            <h1 class="text-4xl font-bold text-gray-900 sm:text-5xl">
              Visor web
              <strong class="text-indigo-600"> DICOM zero-footprint</strong>
            </h1>

            <p class="mt-4 text-base text-pretty text-gray-700 sm:text-lg/relaxed text-justify">
              Utilice herramientas necesarias y avanzadas para diferentes tipos de modalidades
              haciendo uso solamente del navegador web. Visor web avanzado de imágenes DICOM basado
              en HTML5 y Javascript.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Integracion section -->
    <section class="py-10 bg-gray-100 sm:py-16 lg:py-24">
      <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div
          class="grid items-center grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 xl:grid-cols-6 sm:gap-x-12 gap-y-12"
        >
          <div class="lg:col-span-2 sectionAnimate">
            <h2 class="text-base/7 font-semibold text-indigo-600">Nos integramos con</h2>
            <h2
              class="text-3xl font-bold leading-tight text-gray-800 sm:text-4xl lg:text-5xl lg:leading-tight"
            >
              Múltiples plataformas
            </h2>
            <p class="mt-6 text-base text-gray-600">
              Nuestra solución cuenta con múltiples integraciones con aplicaciones del mercado tales
              como:
            </p>
          </div>

          <div class="lg:col-span-3 xl:col-span-4">
            <div
              class="grid items-center max-w-2xl grid-cols-2 mx-auto lg:grid-cols-4 gap-x-4 gap-y-8"
            >
              <div>
                <img
                  class="object-contain w-full h-32 mx-auto fadeInSlow"
                  style="animation-delay: 200ms"
                  src="@/assets/images/marcas/horos.png"
                  alt=""
                />
              </div>

              <div>
                <img
                  class="object-contain w-full h-32 mx-auto fadeInSlow"
                  style="animation-delay: 400ms"
                  src="@/assets/images/marcas/OsiriX.png"
                  alt=""
                />
              </div>

              <div>
                <img
                  class="object-contain w-full h-35 mx-auto fadeInSlow"
                  style="animation-delay: 600ms"
                  src="@/assets/images/marcas/radiant.png"
                  alt=""
                />
              </div>

              <div>
                <img
                  class="object-contain w-full mx-auto h-32 fadeInSlow"
                  style="animation-delay: 800ms"
                  src="@/assets/images/marcas/HL7.png"
                  alt=""
                />
              </div>

              <div>
                <img
                  class="object-contain w-full h-40 mx-auto fadeInSlow"
                  style="animation-delay: 1000ms"
                  src="@/assets/images/marcas/weasis.png"
                  alt=""
                />
              </div>
              <div>
                <img
                  class="object-contain w-full h-24 mx-auto fadeInSlow"
                  style="animation-delay: 1200ms"
                  src="@/assets/images/marcas/radiant2.png"
                  alt=""
                />
              </div>
              <div>
                <img
                  class="object-contain w-full h-40 mx-auto fadeInSlow"
                  style="animation-delay: 1400ms"
                  src="@/assets/images/marcas/mirth.png"
                  alt=""
                />
              </div>
              <div>
                <img
                  class="object-contain w-full mx-auto h-40 fadeInSlow"
                  style="animation-delay: 1600ms"
                  src="@/assets/images/marcas/HL7.FHIR.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- productos section -->
    <section id="productos" class="section">
      <div class="py-24 sm:py-32">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          <div class="mx-auto max-w-2xl lg:text-center sectionAnimate">
            <h2 class="text-base/7 font-semibold text-indigo-600">
              Nuestras Soluciones Innovadoras
            </h2>
            <p
              class="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance text-white"
            >
              Servicios y productos
            </p>
            <p class="mt-6 text-lg/8 text-gray-600 text-white">
              Acelera tus procesos con tecnología avanzada y estándares de calidad que garantizan
              eficiencia, seguridad e integración sin complicaciones.
            </p>
          </div>
          <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-7xl">
            <dl class="grid lg:grid-cols-3 lg:gap-y-[4vw] gap-x-[2vw] gap-y-[10vw] grid-cols-1">
              <div class="relative pl-16 fadeIn" style="animation-delay: 200ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1M9 12H4m8 8V9h8v11h-8Zm0 0H9m8-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                      />
                    </svg>
                  </div>
                  MPACS
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Nuestro PACS es estándar DICOM lo cual permite el almacenamiento, consulta y
                  recuperación de cualquier estudio radiológico en formato DICOM
                </dd>
              </div>

              <div class="relative pl-16 fadeIn" style="animation-delay: 400ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
                      />
                    </svg>
                  </div>
                  MRIS
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Nuestro RIS se encuentra construido con altos estándares de desarrollo y
                  desempeño, se adhiere a los estándares de la salud (HL7 y DICOM).
                </dd>
              </div>

              <div class="relative pl-16 fadeIn" style="animation-delay: 600ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                  </div>
                  MRIS ECG
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Disponemos de una variación de nuestro RIS para visualizar e informar
                  electrocardiogramas (ECG).
                </dd>
              </div>

              <div class="relative pl-16 fadeIn" style="animation-delay: 800ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                  </div>
                  MRIS DENTAL
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Disponemos de una variación de nuestro RIS para visualizar e informar radiografías
                  dentales.
                </dd>
              </div>

              <div class="relative pl-16 fadeIn" style="animation-delay: 1000ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 17h3a3 3 0 0 0 0-6h-.025a5.56 5.56 0 0 0 .025-.5A5.5 5.5 0 0 0 7.207 9.021C7.137 9.017 7.071 9 7 9a4 4 0 1 0 0 8h2.167M12 19v-9m0 0-2 2m2-2 2 2"
                      />
                    </svg>
                  </div>
                  Integración
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Implementamos integraciones con cualquier sistema informático que cumpla o no
                  cumpla con estándares HL7 o DICOM.
                </dd>
              </div>

              <div class="relative pl-16 fadeIn" style="animation-delay: 1200ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 16v-4a8 8 0 1 0-16 0v4m16 0v2a2 2 0 0 1-2 2h-2v-6h2a2 2 0 0 1 2 2ZM4 16v2a2 2 0 0 0 2 2h2v-6H6a2 2 0 0 0-2 2Z"
                      />
                    </svg>
                  </div>
                  Soporte
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Disponemos de soporte 24/7 con contacto directo con nuestros ingenieros.
                </dd>
              </div>

              <div class="relative pl-16 fadeIn" style="animation-delay: 1400ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14.7141 15h4.268c.4043 0 .732-.3838.732-.8571V3.85714c0-.47338-.3277-.85714-.732-.85714H6.71411c-.55228 0-1 .44772-1 1v4m10.99999 7v-3h3v3h-3Zm-3 6H6.71411c-.55228 0-1-.4477-1-1 0-1.6569 1.34315-3 3-3h2.99999c1.6569 0 3 1.3431 3 3 0 .5523-.4477 1-1 1Zm-1-9.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.49999-1.1193-2.49999-2.5S8.8334 9 10.2141 9s2.5 1.1193 2.5 2.5Z"
                      />
                    </svg>
                  </div>
                  Estaciones de Trabajo
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Venta e instalación de estaciones de trabajo de 1 y 2 pantallas diagnósticas Jusha
                  (3MP y 5MP)
                </dd>
              </div>

              <div class="relative pl-16 fadeIn" style="animation-delay: 1600ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm7 11-6-2V9l6-2v10Z"
                      />
                    </svg>
                  </div>
                  Grabadores Robóticos
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Venta e instalación de robots de grabado automático de CD/DVD DICOM para entrega a
                  pacientes.
                </dd>
              </div>

              <div class="relative pl-16 fadeIn" style="animation-delay: 1800ms">
                <dt class="font-semibold text-white md:text-left text-left">
                  <div
                    class="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg bg-indigo-600"
                  >
                    <svg
                      class="size-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z"
                      />
                    </svg>
                  </div>
                  Hardware e Insumos
                </dt>
                <dd class="mt-2 text-gray-600 text-white md:text-left text-left">
                  Venta de computadores e insumos en general, consulta de catálogo en tienda
                  virtual.
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
    <!-- EQUIPO MEDICO section -->
    <section
      id="equipo-medico"
      class="relative overflow-hidden bg-gradient-to-br from-gray-50 via-indigo-50 to-white py-20"
    >
      <!-- Patrón SVG en el fondo -->
      <!-- <div class="logo-lg"></div> -->
      <div class="absolute inset-0 z-0 opacity-60">
        <svg width="100%" height="100%" class="text-indigo-100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
              <path d="M 60 0 L 0 0 0 60" fill="none" stroke="currentColor" stroke-width="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>
      <div class="mx-auto max-w-3xl lg:text-center sectionAnimate">
        <h2 class="text-base/7 font-semibold text-gray-900">Productos Médicos</h2>
        <p
          class="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance"
        >
          ¡Impulsa la precisión médica con la
          <strong class="text-indigo-600">tecnología avanzada!</strong>
        </p>
        <p class="mt-6 text-lg/8 text-gray-600">
          Conoce nuestra línea de monitores médicos y detectores digitales, desarrollados para
          entregar imágenes nítidas, confiables y de alta resolución. Mejora tus diagnósticos y
          procedimientos quirúrgicos con soluciones diseñadas para elevar la calidad de la atención
          médica.
        </p>
      </div>
      <div class="mx-auto mt-8 max-w-2xl sm:mt-20 lg:mt-16 lg:max-w-7xl">
        <div class="-mx-4 flex flex-wrap">
          <div class="w-full px-4 md:w-1/2 xl:w-1/4">
            <div class="relative mx-auto mb-10 max-w-[370px] text-center">
              <div
                class="absolute -right-4 top-12 hidden h-1 w-16 border-t-2 border-dashed border-primary xl:block 2xl:w-[75px]"
              ></div>
              <div
                class="relative mx-auto mb-8 flex h-[100px] w-[100px] items-center justify-center rounded-[80px] bg-indigo-600 text-white text-4xl shadow-lg border border-indigo-200"
              >
                1
              </div>
              <h3 class="mb-5 text-2xl font-semibold text-dark">Precisión en la Imagen</h3>
              <p class="dark:text-dark-6 text-base text-body-color">
                Los monitores médicos están diseñados para ofrecer una calidad de imagen superior,
                con resolución alta y una fidelidad de color precisa, lo que facilita diagnósticos
                más exactos.
              </p>
            </div>
          </div>
          <!-- PASO 2 -->
          <div class="w-full px-4 md:w-1/2 xl:w-1/4">
            <div class="relative mx-auto mb-10 max-w-[370px] text-center">
              <div
                class="absolute -left-4 top-12 hidden h-1 w-16 border-t-2 border-dashed border-primary xl:block 2xl:w-[75px]"
              ></div>
              <div
                class="absolute right-[-14px] top-12 hidden h-1 w-16 border-t-2 border-dashed border-primary xl:block 2xl:w-[75px]"
              ></div>
              <div
                class="mx-auto mb-8 flex h-[100px] w-[100px] items-center justify-center rounded-[80px] bg-indigo-600 text-white text-4xl shadow-lg border border-indigo-200"
              >
                2
              </div>
              <h3 class="mb-5 text-2xl font-semibold text-dark">
                Mejora en la Seguridad del Paciente
              </h3>
              <p class="dark:text-dark-6 text-base text-body-color">
                La visualización clara y exacta de las imágenes ayuda a detectar detalles críticos,
                reduciendo errores y mejorando la atención y seguridad del paciente.
              </p>
            </div>
          </div>
          <!-- PASO 3 -->
          <div class="w-full px-4 md:w-1/2 xl:w-1/4">
            <div class="relative mx-auto mb-10 max-w-[370px] text-center">
              <div
                class="absolute -left-4 top-12 hidden h-1 w-16 border-t-2 border-dashed border-primary xl:block 2xl:w-[75px]"
              ></div>
              <div
                class="absolute right-[-14px] top-12 hidden h-1 w-16 border-t-2 border-dashed border-primary xl:block 2xl:w-[75px]"
              ></div>
              <div
                class="mx-auto mb-8 flex h-[100px] w-[100px] items-center justify-center rounded-[80px] bg-indigo-600 text-white text-4xl shadow-lg border border-indigo-200"
              >
                3
              </div>
              <h3 class="mb-5 text-2xl font-semibold text-dark">Confiabilidad y Durabilidad</h3>
              <p class="dark:text-dark-6 text-base text-body-color">
                Los monitores médicos están diseñados para un uso constante en entornos clínicos,
                garantizando rendimiento consistente y duradero frente a largas jornadas de trabajo.
              </p>
            </div>
          </div>
          <div class="w-full px-4 md:w-1/2 xl:w-1/4">
            <div class="relative mx-auto mb-10 max-w-[370px] text-center">
              <div
                class="absolute left-[-14px] top-12 hidden h-1 w-16 border-t-2 border-dashed border-primary xl:block 2xl:w-[75px]"
              ></div>
              <div
                class="mx-auto mb-8 flex h-[100px] w-[100px] items-center justify-center rounded-[80px] bg-indigo-600 text-white text-4xl shadow-lg border border-indigo-200"
              >
                4
              </div>
              <h3 class="mb-5 text-2xl font-semibold text-dark">
                Facilita la Transformación Digital
              </h3>
              <p class="dark:text-dark-6 text-base text-body-color">
                La integración con otras tecnologías hospitalarias y sistemas de gestión médica
                permite una atención más eficiente y moderna.
              </p>
            </div>
          </div>
        </div>

        <!-- Botón -->
        <div class="relative z-10 mt-10 text-center">
          <a
            href="productos-medicos"
            target="_blank"
            class="inline-block rounded-md bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-md hover:bg-indigo-500 transition"
          >
            Conoce Nuestros Productos
          </a>
        </div>
      </div>
    </section>

    <!-- nosotros section -->
    <section id="nosotros" class="section bg-nosotros">
      <div class="grid grid-cols-2 gap-4 flex-col grid-cols-1-op">
        <div class="flex justify-center flex-col w-600 fadeIn">
          <p
            class="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance"
          >
            Profesionales con años de <strong class="text-indigo-600">experiencia</strong>
          </p>
          <p class="mt-6 text-lg/8 justify-center text-justify mx-4">
            En Optimuz Spa, contamos con más de 10 años de experiencia en la implementación de
            sistemas RIS PACS y la venta de hardware especializado para el sector salud. Nuestra
            experiencia nos permite ofrecer soluciones innovadoras y eficientes para la gestión de
            estudios de imagenología, garantizando una integración perfecta en su entorno médico.
          </p>
        </div>
        <div class="col-end-3 hidden-op"></div>
      </div>
    </section>

    <!-- Testimonials section -->
    <section
      id="testimonials"
      aria-label="Opiniones Reales, Experiencias Auténticas"
      class="section"
    >
      <div class="mx-auto max-w-7xl py-24 sm:py-16 px-4 sm:px-6 lg:px-8">
        <div class="mx-auto max-w-2xl md:text-center fadeIn">
          <h2 class="text-base/7 font-semibold text-indigo-600">Opiniones Reales</h2>
          <p
            class="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance"
          >
            Experiencias Auténticas
          </p>
        </div>
        <ul
          role="list"
          class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:gap-8 lg:mt-20 lg:max-w-none lg:grid-cols-3"
        >
          <li>
            <ul role="list" class="flex flex-col gap-y-6 sm:gap-y-8">
              <li>
                <figure
                  class="relative rounded-2xl bg-white p-6 shadow-xl shadow-slate-900/10 fadeInUp"
                >
                  <svg
                    aria-hidden="true"
                    width="105"
                    height="78"
                    class="absolute left-6 top-6 fill-slate-100"
                  >
                    <path
                      d="M25.086 77.292c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622C1.054 58.534 0 53.411 0 47.686c0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C28.325 3.917 33.599 1.507 39.324 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Zm54.24 0c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622-2.11-4.52-3.164-9.643-3.164-15.368 0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C82.565 3.917 87.839 1.507 93.564 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Z"
                    ></path>
                  </svg>
                  <blockquote class="relative">
                    <p class="text-lg tracking-tight text-slate-900">
                      Profesionales con conocimientos sólidos de los flujos de trabajo en
                      imagenología y de los estándares utilizados.
                    </p>
                  </blockquote>
                  <figcaption
                    class="relative mt-6 flex items-center justify-between border-t border-slate-100 pt-6"
                  >
                    <div>
                      <div class="font-display text-base text-slate-900 font-bold text-left">
                        María Caro
                      </div>
                      <div class="font-display text-base text-slate-900">Gerente Informática</div>
                    </div>
                    <!-- First testimonial -->
                    <div class="overflow-hidden rounded-full bg-slate-50">
                      <img
                        :src="testimonials.image3"
                        alt="María Caro"
                        class="h-14 w-14 object-cover"
                      />
                    </div>
                  </figcaption>
                </figure>
              </li>
            </ul>
          </li>
          <li>
            <ul role="list" class="flex flex-col gap-y-6 sm:gap-y-8">
              <li>
                <figure class="relative rounded-2xl bg-white p-6 shadow-xl shadow-slate-900/10">
                  <svg
                    aria-hidden="true"
                    width="105"
                    height="78"
                    class="absolute left-6 top-6 fill-slate-100"
                  >
                    <path
                      d="M25.086 77.292c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622C1.054 58.534 0 53.411 0 47.686c0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C28.325 3.917 33.599 1.507 39.324 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Z"
                    ></path>
                  </svg>
                  <blockquote class="relative">
                    <p class="text-lg tracking-tight text-slate-900">
                      Necesitábamos un RIS en la nube; la solución cumplió con los requisitos y se
                      implementó rápidamente.
                    </p>
                  </blockquote>
                  <figcaption
                    class="relative mt-6 flex items-center justify-between border-t border-slate-100 pt-6"
                  >
                    <div>
                      <div class="font-display text-base text-slate-900 font-bold text-left">
                        Daniel Perez
                      </div>
                      <div class="font-display text-base text-slate-900">Gerente General</div>
                    </div>
                    <!-- Second testimonial -->
                    <div class="overflow-hidden rounded-full bg-slate-50">
                      <img
                        :src="testimonials.image2"
                        alt="Daniel Perez"
                        class="h-14 w-14 object-cover"
                      />
                    </div>
                  </figcaption>
                </figure>
              </li>
            </ul>
          </li>
          <li>
            <ul role="list" class="flex flex-col gap-y-6 sm:gap-y-8">
              <li>
                <figure class="relative rounded-2xl bg-white p-6 shadow-xl shadow-slate-900/10">
                  <svg
                    aria-hidden="true"
                    width="105"
                    height="78"
                    class="absolute left-6 top-6 fill-slate-100"
                  >
                    <path
                      d="M25.086 77.292c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622C1.054 58.534 0 53.411 0 47.686c0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C28.325 3.917 33.599 1.507 39.324 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Z"
                    ></path>
                  </svg>
                  <blockquote class="relative">
                    <p class="text-lg tracking-tight text-slate-900">
                      Excelente partner, buen producto y soporte de los sistemas RIS PACS
                      implementados. Excelente tiempo de respuesta.
                    </p>
                  </blockquote>
                  <figcaption
                    class="relative mt-6 flex items-center justify-between border-t border-slate-100 pt-6"
                  >
                    <div>
                      <div class="font-display text-base text-slate-900 font-bold text-left">
                        Oscar Estay
                      </div>
                      <div class="font-display text-base text-slate-900">Gerente General</div>
                    </div>
                    <!-- Third testimonial -->
                    <div class="overflow-hidden rounded-full bg-slate-50">
                      <img
                        :src="testimonials.image1"
                        alt="Oscar Estay"
                        class="h-14 w-14 object-cover"
                      />
                    </div>
                  </figcaption>
                </figure>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </section>

    <!-- Contacto section -->
    <section id="contacto" class="section">
      <Contacto />
    </section>

    <!-- Footer section -->
    <footer>
      <div class="bg-gray-100">
        <div
          class="max-w-screen-lg py-10 px-4 sm:px-6 text-gray-800 sm:flex justify-between mx-auto"
        >
          <div class="p-5 sm:w-2/12 border-r">
            <div class="text-sm uppercase text-indigo-600 font-bold">Menu</div>
            <ul>
              <li class="my-2">
                <a class="hover:text-indigo-600" href="#inicio">Inicio</a>
              </li>
              <li class="my-2">
                <a class="hover:text-indigo-600" href="#productos">Productos y Servicios</a>
              </li>
              <li class="my-2">
                <a class="hover:text-indigo-600" href="#nosotros">Nosotros</a>
              </li>
              <li class="my-2">
                <a class="hover:text-indigo-600" href="#contacto">Contacto</a>
              </li>
            </ul>
          </div>
          <div class="p-5 sm:w-7/12 border-r text-center">
            <h3 class="font-bold text-xl text-indigo-600 mb-4">OPTIMUZ SPA</h3>
            <h1 class="text-gray-500 text-sm mb-10 text-justify">
              Nuestra solución MRIS y MPACS permite la optimización de la gestión de estudios de
              imagenología, mejorando la programación de citas, el seguimiento de pacientes, la
              interpretación de imágenes y la entrega de resultados. Con nuestra plataforma, aumente
              la eficiencia, precisión y accesibilidad de los servicios de radiología, ofreciendo
              una atención médica más ágil y precisa.
            </h1>
          </div>
          <div class="p-5 sm:w-3/12">
            <div class="text-sm uppercase text-indigo-600 font-bold">Información</div>
            <ul>
              <li class="my-2">
                <a class="hover:text-indigo-600">Compañía de Jesús 1390 Of. 2204, Santiago</a>
              </li>
              <li class="my-2">
                <a
                  class="hover:text-indigo-600 hover:text-indigo-600"
                  href="mailto:contacto@optimuz.cl"
                  >contacto@optimuz.cl
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="flex py-5 m-auto text-gray-800 text-sm flex-col items-center border-t max-w-screen-xl"
        >
          <div class="my-5">© Copyright 2025. All Rights Reserved OPTIMUZ SPA.</div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import { pageSEO } from '@/config/seo.js';
import NavBar from "@/components/NavBar.vue";
import Carousel from "@/components/Carousel.vue";
import Contacto from "@/components/Contacto.vue";
import HeroOptimuz from "@/assets/images/Hero-optimuz.jpg";
import TestimonialImage1 from "@/assets/images/testimonio/oscar-estay.jpg";
import TestimonialImage2 from "@/assets/images/testimonio/daniel-perez.jpg";
import TestimonialImage3 from "@/assets/images/testimonio/maria-caro.jpg";
import DashboardScreenshot1 from "@/assets/images/visores/dashboard-screenshot.jpg";
import DashboardScreenshot2 from "@/assets/images/visores/dashboard-screenshot-2.jpg";
import DashboardScreenshot3 from "@/assets/images/visores/dashboard-screenshot-3.jpg";
import DashboardScreenshot4 from "@/assets/images/visores/dashboard-screenshot-4.jpg";
import imgDictactoVoz from "@/assets/images/dictado-por-voz.jpg";
import imgVisorWeb from "@/assets/images/OHIF.gif";

export default {
  name: "Home",
  components: {
    NavBar,
    Carousel,
    Contacto,
  },
  setup() {
    useHead(pageSEO.home);
  },
  data() {
    return {
      HerOptimuz: HeroOptimuz,
      imagenDictado: imgDictactoVoz,
      imgenVisorWeb: imgVisorWeb,
      testimonials: {
        image1: TestimonialImage1,
        image2: TestimonialImage2,
        image3: TestimonialImage3,
      },
      carouselItems: [
        {
          image: DashboardScreenshot1,
          alt: "Imagen 1",
          text: "Descripción 1",
        },
        {
          image: DashboardScreenshot2,
          alt: "Imagen 1",
          text: "Descripción 1",
        },
        {
          image: DashboardScreenshot3,
          alt: "Imagen 1",
          text: "Descripción 1",
        },
        {
          image: DashboardScreenshot4,
          alt: "Imagen 1",
          text: "Descripción 1",
        },
      ],
    };
  },
  mounted() {
    this.initScrollAnimation();
  },
  methods: {
    initScrollAnimation() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Agrego diferentes clases de animación
              if (entry.target.classList.contains("fade-right")) {
                entry.target.classList.add("animate-fade-in-right");
              } else if (entry.target.classList.contains("fade-left")) {
                entry.target.classList.add("animate-fade-in-left");
              } else if (entry.target.classList.contains("fadeInSlow")) {
                entry.target.classList.add("animate-fade-in-slow");
              } else if (entry.target.classList.contains("fadeIn")) {
                entry.target.classList.add("animate-fade-in");
              } else {
                entry.target.classList.add("animate-fade-in-up");
              }
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: "0px",
        }
      );

      document
        .querySelectorAll(".sectionAnimate, .fade-right, .fade-left, .fadeIn, .fadeInSlow ")
        .forEach((section) => {
          observer.observe(section);
        });
    },
  },
};
</script>
